import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import UserAvatarImage from '../user-avatar-image';
import UserBadge from '../user-badge';
import styles from './avatar.scss';

function Avatar({ type, user = {} }) {
  const className = classNames(styles.container, 'forum-text-color', { [styles[type]]: type }, 'avatar');
  return (
    <div className={classNames(className)}>
      <UserAvatarImage type={type} user={user}/>
      <span className={classNames(styles.name)} data-hook="avatar__name">
        {user.name}
      </span>
      <UserBadge user={user}/>
    </div>
  );
}

Avatar.LARGE = 'large';

Avatar.propTypes = {
  user: PropTypes.object.isRequired,
  type: PropTypes.string,
};

export default Avatar;



// WEBPACK FOOTER //
// ./app/components/avatar/avatar.js